<template>
    <div>
        <div class="video">
            <img src="@/assets/zhuan1.png" alt="">
        </div>
        <van-tabs v-model="active">
            <van-tab title="目录">
                <div class="title"  @click="xian">
                    <van-icon name="play"/>识字一</div>
                    <ul v-show="show">
                        <li>识字一</li>
                        <li>识字一</li>
                        <li>识字一</li>
                    </ul>
            </van-tab>
            <van-tab title="简介">

            </van-tab>
        </van-tabs>

    </div>
</template>

<script>
import Vue from 'vue';
import { Tab, Tabs } from 'vant';
import { Icon } from 'vant';

Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
export default {
    data() {
        return {
            active: 2,
            show:false
        }
    },
    methods:{
        xian(){
            this.show = !this.show
            console.log(123);
        }
    }
}
</script>

<style scoped>
.video{
    width: 100%;
    height: 200px;
    margin-bottom: 100px;
}
.video img {
    width: 100%; 
}
.title{
    line-height: 44px;
    text-indent: 5px;
}
li{
    text-indent: 30px;
    line-height: 44px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Details/details.vue